<template>
  <div class="supervisor-info-view" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="设计师详情" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="supervisor-detail">
      <div class="top">
        <img class="supervisor-avatar" :src="imgUrl + supervisor.avatar">
        <img class="supervisor-avatar-design" src="../../assets/icon-platform-design.png" alt="">
        <div class="case-info">
          <div class="label">设计案例</div>
          <div class="num">{{supervisor.projectCount}}</div>
          <div class="label">设计中</div>
          <div class="num">{{supervisor.projectingCount}}</div>
        </div>
      </div>
      <div class="bottom">
        <div class="name">{{supervisor.name}}</div>
        <div class="appointment-info">
          <div class="label">已预约</div>
          <div class="num first">{{supervisor.appointmentCount}}</div>
          <div class="label">可预约</div>
          <div class="num">{{supervisor.spares}}</div>
        </div>
      </div>
    </div>
    <div class="supervisor-detail-tab">
      <div class="tab-item" @click="isLabel(0)" :class = "{'selected':isLabelNum == 0}">自述</div>
      <div class="tab-item" @click="isLabel(3)" :class = "{'selected':isLabelNum == 3}">服务内容</div>
      <div class="tab-item" @click="isLabel(1)" :class = "{'selected':isLabelNum == 1}">设计案例</div>
      <div class="tab-item" @click="isLabel(2)" :class = "{'selected':isLabelNum == 2}">评价</div>
    </div>
    <div class="intro" v-if="isLabelNum == 0">
      <div class="content" v-if="supervisor.intro">{{supervisor.intro}}</div>
      <div v-else-if="!supervisor.intro" class="black-page">
        <img src="../../assets/icon-no-img.png">
        <div class="tip">该设计师还没有自述哦!</div>
      </div>
    </div>
    <div class="intro" v-if="isLabelNum == 3">
      <div v-if="supervisor.serviceContent" class="service-content" v-html="supervisor.serviceContent"></div>
      <div v-if="!supervisor.serviceContent" class="black-page">
        <img src="../../assets/icon-no-img.png">
        <div class="tip">暂无该设计师的服务内容!</div>
      </div>
    </div>
    <div class="project-list" v-if="isLabelNum == 1">
      <div class="project-item" v-for="(caseProject,index) in caseList" v-if="index < 3" @click="openCaseProject(caseProject.projectId)">
        <img v-if="caseProject.cover" :src="imgUrl + caseProject.cover">
        <img v-else="" src="../../assets/icon-project-default-cover.png">
        <div class="project-info">
          <div class="name">{{caseProject.onestopProjectName}}</div>
        </div>
        <div class="project-status">
          <div class="state" v-if="caseProject.status == '4'">设计中</div>
          <div class="state" v-if="caseProject.status == '6'">已完工</div>
          <div>{{caseProject.onestopProject.houseLayout}}</div>
        </div>
      </div>
      <div class="loading-more" v-if="caseList.length > 3" @click="openCaseList()">
        <!-- <span>查看其余{{caseList.length - 3}}个</span> -->
        <span>查看更多案例</span>
        <img class="more" src="../../assets/icon-more.png">
      </div>
      <div v-if="caseList.length == 0" class="black-page">
        <img src="../../assets/icon-no-img.png">
        <div class="tip">暂无该设计师的相关案例!</div>
      </div>
    </div>
    <div class="evaluate-list" v-if="isLabelNum == 2">
      <div class="evaluate-item" v-for="evaluate in customerEvaluateList">
        <img v-if="evaluate.customerAvatar" :src="evaluate.customerAvatar">
        <img v-if="!evaluate.customerAvatar" src="../../assets/icon/icon-defualt-avatar.png">
        <div class="evaluate-info">
          <div class="name">{{evaluate.customerName}}</div>
          <div class="date">{{evaluate.createTime | simpleDayFilter}}
            <img v-if="evaluate.update" class="icon-evaluate-edit-btn" @click="toCustomerEvaluateEdit(evaluate.id)" src="../../assets/icon-evaluate-reEdit.png"/>
          </div>
          <div class="content">{{evaluate.content}}</div>
        </div>
        <div class="evaluate-score">
          <div class="score">{{evaluate.score | score}}</div>
        </div>
      </div>
      <div v-if="customerEvaluateList.length == 0" class="black-page">
        <img src="../../assets/icon-no-img.png">
        <div class="tip">暂无该设计师的相关评价信息!</div>
      </div>
    </div>
    <div class="appointment-btn" @click="openSupervisorReservation(supervisor)">预约</div>
  </div>
</template>

<script>
import {Toast} from 'mint-ui'
import Header from '../../components/header/Header'
import {imgUrl,shareIcon} from '../../config'
import SupervisorService from '../../service/SupervisorService'
import onestopProjectSupervisorService from '../../service/onestop/OnestopProjectSupervisorService'
import EvaluateService from '../../service/customer/EvaluateService'
import shareService from '../../service/share/ShareService'

export default {
  name: 'SupervisorDetail',
  components: {
    'my-header': Header,
  },
  data () {
    return {
      isLabelNum:0,
      supervisorId:'',
      supervisorType:'5',
      supervisor:{},
      customerEvaluateList:[],
      caseList:[],
      guaranteeList:[],
      imgUrl: imgUrl,
      shareIcon:shareIcon,
      isWechatBrowser:this.$verfyBrowserType(),
      supervisorName:'',
      designPrice:''
    }
  },
  created(){
    this.supervisorName = this.$route.query.supervisorName;
    this.supervisorId = this.$route.query.supervisorId;
    if(this.global.isLabelNum){
      this.isLabelNum = this.global.isLabelNum;
      this.isLabel(this.isLabelNum);
      this.global.isLabelNum = 0;
    }
  },
  beforeMount () {
    document.title = this.$route.meta.title;
    this.getSupervisorInfo(this.supervisorId);
  },
  methods: {
    isLabel(num){
      if(num == 1){
        this.isLabelNum=1;
        this.getCaseList();
      }else if(num == 2){
        this.isLabelNum=2;
        this.getEvaluateList();
      }else if(num == 3){
        this.isLabelNum=3;
      }else {
        this.isLabelNum=0;
      }
    },
    openCaseList(){
      this.global.isLabelNum = this.isLabelNum;
      this.$router.push({name:'DesignerCaseList',query:{ supervisorId:this.supervisorId, supervisorType:this.supervisorType }});
    },
    openCaseProject(id){
      this.global.isLabelNum = this.isLabelNum;
      this.$router.push({name:'Project',query:{id:id}});
    },
    toCustomerEvaluateEdit(id){
      this.global.isLabelNum = this.isLabelNum;
      this.$router.push({name:'CustomerEvaluateEdit',query:{id}});
    },
    openSupervisorReservation(supervisor){
      this.global.isLabelNum = this.isLabelNum;
      if(supervisor.appointmentSwitch != '1'){
        Toast('该设计师暂时不接受预约!');
      }else if(supervisor.appointmentSwitch == '1' && supervisor.spares == 0){
        Toast('该设计师预约已满!');
      }else {
        if(!!this.global.isMiniProgrm ){
          wx.miniProgram.navigateTo({url: `/pages/gangmaster/reservation?id=${supervisor.id}&companyId=${supervisor.companyId}&deposit=${supervisor.deposit}&supervisorName=${supervisor.name}&type=6`});
        }else {
          this.$router.push({name:'DesignerReservation',query:{id:supervisor.id,supervisorName:supervisor.name,deposit:supervisor.deposit}});
        }
      }
    },
    async getSupervisorInfo(id){
      var result = await SupervisorService.getSupervisorDetail(id);
      if(result.code == 0){
        this.supervisor = result.data;
        console.info(this.supervisor)
      }else {
        Toast('获取设计师详细信息失败');
      }
    },
    async getEvaluateList(){
      var result = await EvaluateService.evaluateList(this.supervisorId,this.supervisor.companyId,'',this.supervisorType,'1');
      if(result.code == 0){
        this.customerEvaluateList = result.data;
        for (let evaluate of this.customerEvaluateList) {
          evaluate.customerName = evaluate.onestopProject.customerName;
          if(evaluate.customerUser != null){
            evaluate.customerAvatar = evaluate.customerUser.avatarUrl;
          }else if(evaluate.customerAvatar){
            evaluate.customerAvatar = this.imgUrl + evaluate.customerAvatar;
          }
          let projectName = evaluate.onestopProject.name;
          if(projectName && projectName.length > 17){
            projectName = projectName.substring(0,14) + '...';
          }
          this.$set(evaluate,'projectName',projectName);
        }
      }else {
        Toast('获取设计师评价信息失败');
      }
    },
    async getCaseList(){
      var result = await onestopProjectSupervisorService.cases(this.supervisorId);
      if(result.code == 0){
        this.caseList = [];
        for(let caseProject of result.data.result){
          if(caseProject.status != 7){
            if(caseProject.onestopProject.renderings){
              let renderingsArray = caseProject.onestopProject.renderings.split(',');
              caseProject.cover = renderingsArray[0];
            }
            this.caseList.push(caseProject);
          }
        }
      }else {
        Toast('获取设计师案例信息失败');
      }
    },
    async initWechatShare(){
      let title = "推荐水木家居商城优选设计师";// 分享标题
      let desc = "我在水木家居商城找到一位好设计师“"+this.supervisorName+"”，推荐给想装修的朋友！"; // 分享描述
      let link = window.location.href; // 分享链接
      link = link.replace(/#/, '?#');
      await shareService.wechatShare(title,desc,link,this.shareIcon);
    },
  }
}
</script>
<style lang="scss">
@import '../../assets/style/supervisor-detail.scss';
.supervisor-info-view .supervisor-detail{
  padding-bottom: 0rem;
  border-bottom: none;
}
.supervisor-info-view .supervisor-detail .top .supervisor-avatar-design{
  position: absolute;
  top: 1.57rem;
  left: 0.65rem;
  width: 1.5rem;
  height: 0.6rem;
}
.service-content{
  margin-bottom: 0.24rem;
  padding: 0.4rem 0.3rem 0.34rem;
  border-radius: 0.1rem;
  border: solid 1px #eee;
  line-height: 0.46rem;
  font-weight: bold;
  img{
    max-width: 100%;
    border-radius: 0.15rem;
    margin-bottom: 0.2rem;
  }
}
</style>

